// Comprehensive list of medical specialties
export const MEDICAL_SPECIALISTS = [
  // Primary Care
  'General Physician',
  'Family Medicine',
  'Internal Medicine',
  
  // Surgery
  'General Surgeon',
  'Orthopedic Surgeon',
  'Neurosurgeon',
  'Cardiothoracic Surgeon',
  'Plastic Surgeon',
  'Pediatric Surgeon',
  'Vascular Surgeon',
  'Trauma Surgeon',
  
  // Medical Specialties
  'Cardiologist',
  'Neurologist',
  'Gastroenterologist',
  'Pulmonologist',
  'Nephrologist',
  'Endocrinologist',
  'Rheumatologist',
  'Hematologist',
  'Oncologist',
  'Infectious Disease Specialist',
  
  // Women & Children
  'Obstetrician',
  'Gynecologist',
  'Pediatrician',
  'Neonatologist',
  
  // Diagnostic
  'Radiologist',
  'Pathologist',
  'Clinical Pathologist',
  
  // Mental Health
  'Psychiatrist',
  'Clinical Psychologist',
  
  // Specialized Medicine
  'Dermatologist',
  'Ophthalmologist',
  'ENT Specialist',
  'Urologist',
  'Anesthesiologist',
  'Emergency Medicine',
  'Critical Care Specialist',
  'Geriatrician',
  'Allergist',
  'Immunologist',
  
  // Allied Health
  'Physiotherapist',
  'Dentist',
  'Orthodontist',
  'Oral Surgeon',
  
  // Nutrition & Lifestyle
  'Dietitian',
  'Nutritionist',
  'Sports Medicine',
  
  // Other
  'Pain Management Specialist',
  'Rehabilitation Medicine',
  'Public Health Specialist',
  'Occupational Medicine',
  'Sleep Medicine Specialist'
].sort();

/**
 * Generate a consistent color based on string hash
 * @param {string} text - The text to generate color from
 * @returns {string} - Hex color code
 */
export const stringToColor = (text) => {
  if (!text) return '#6B7280'; // Gray for empty
  
  // Generate hash
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Generate HSL color with good saturation and lightness for readability
  const h = Math.abs(hash % 360);
  const s = 65 + (Math.abs(hash) % 20); // 65-85% saturation
  const l = 45 + (Math.abs(hash >> 8) % 15); // 45-60% lightness
  
  return hslToHex(h, s, l);
};

/**
 * Convert HSL to Hex
 */
const hslToHex = (h, s, l) => {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;
  let r = 0, g = 0, b = 0;

  if (0 <= h && h < 60) {
    r = c; g = x; b = 0;
  } else if (60 <= h && h < 120) {
    r = x; g = c; b = 0;
  } else if (120 <= h && h < 180) {
    r = 0; g = c; b = x;
  } else if (180 <= h && h < 240) {
    r = 0; g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; g = 0; b = c;
  } else if (300 <= h && h < 360) {
    r = c; g = 0; b = x;
  }

  const toHex = (val) => {
    const hex = Math.round((val + m) * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

/**
 * Get contrasting text color (black or white) for a background color
 */
export const getContrastColor = (hexColor) => {
  // Convert hex to RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

/**
 * Get specialist badge styling
 */
export const getSpecialistBadgeStyle = (specialist) => {
  const bgColor = stringToColor(specialist);
  const textColor = getContrastColor(bgColor);
  
  return {
    backgroundColor: bgColor,
    color: textColor
  };
};
